import React, { useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  BRAND_COLOR,
  BRAND_HOVER,
  KivuI18nContext,
  localizedPath,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";
import { ROUTE_SUBSCRIPTIONS } from "../../constants/routes";
import { dialogTitleCenterSx } from "../common/dialogTitleCenterSx";

interface AlreadyHasSubscriptionModalProps {
  open: boolean;
  onClose: () => void;
  /** Called when user clicks "View my subscription" before navigation (e.g. to close parent modal) */
  onViewSubscription?: () => void;
}

const AlreadyHasSubscriptionModal: React.FC<
  AlreadyHasSubscriptionModalProps
> = ({ open, onClose, onViewSubscription }) => {
  const { t } = useKivunovaTranslation();
  const navigate = useNavigate();
  const { language, defaultLang } = useContext(KivuI18nContext) || {};

  const handleViewSubscription = () => {
    onClose();
    onViewSubscription?.();
    navigate(localizedPath(ROUTE_SUBSCRIPTIONS, language, defaultLang));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={dialogTitleCenterSx}>
        <Typography variant="h6" fontWeight="bold">
          {t("already-has-subscription-modal-title", "Active subscription")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t(
            "already-has-subscription-modal-message",
            "You already have an active subscription."
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {t("already-has-subscription-modal-close", "Close")}
        </Button>
        <Button
          onClick={handleViewSubscription}
          variant="contained"
          sx={{
            backgroundColor: BRAND_COLOR,
            "&:hover": {
              backgroundColor: BRAND_HOVER
            }
          }}
        >
          {t("already-has-subscription-modal-view", "View my subscription")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlreadyHasSubscriptionModal;
